module.exports = __webpack_public_path__ + "static/img/brees-2002-slide-2.245411e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-slide-2.jpg
// module id = S9aU
// module chunks = 1